import { InjectionToken } from '@angular/core';

import { MobiUiLanguage } from '@mobi/rwc-ui-components-ng-jslib';

import { AppContext, AppSource } from '../../common.constant';

import { Links, linksMap } from './link-data-map';

export interface AppSettingProvider {
    getAppSetting(): {
        source: AppSource;
        context: AppContext;
        language: MobiUiLanguage;
        links: Links;
    };
}
export function getLinks(language: MobiUiLanguage, source: AppSource) {
    return linksMap[language][source];
}
export const APP_SETTING_PROVIDER = new InjectionToken<AppSettingProvider>('appSettingProviderConfig');
